import { ApplicationInsights, IPageViewTelemetry } from '@microsoft/applicationinsights-web'
import { Component } from 'react';
import H from "history";
import { connect } from 'react-redux';
import { IRootState } from '../store';
import { AccountInfo } from '@azure/msal-browser';
import DispatchProps from './DispatchProps';

interface ApplicationInsightsProviderProps {
    user?: AccountInfo;
    history: H.History;
}

interface ApplicationInsightsProviderState {

}

const appInsightsConnectionString = process.env.REACT_APP_APPLICATION_INSIGHTS_CONNECTION_STRING;

class ApplicationInsightsProvider extends Component<DispatchProps & ApplicationInsightsProviderProps, ApplicationInsightsProviderState> {

    private appInsights?: ApplicationInsights;
    private unlisten?: H.UnregisterCallback;

    componentDidMount() {

        if (appInsightsConnectionString != undefined) {
            this.appInsights = new ApplicationInsights({
                config: {
                    connectionString: appInsightsConnectionString,
                    disableCookiesUsage: true,
                    disableCorrelationHeaders: false,
                    loggingLevelTelemetry: 0, // OFF
                    loggingLevelConsole: 0 // OFF
                }
            });
        }

        this.appInsights?.loadAppInsights();
        this.appInsights?.trackPageView(this.getPageViewTelemetery(this.props.history.location.pathname));

        this.unlisten = this.props.history.listen((location, action) => {
            this.appInsights?.trackPageView(this.getPageViewTelemetery(location.pathname));
        });
    }

    componentWillUnmount() {
        if (this.unlisten != undefined) {
            this.unlisten();
        }
    }

    getPageViewTelemetery(uri: string): IPageViewTelemetry {
        return {
            uri: uri,
            isLoggedIn: this.props.user != undefined,
            properties: {
                usersTenantId: this.props.user?.tenantId,
                userId: this.props.user?.localAccountId
            }
        };
    }

    public render() {
        return this.props.children;
    }
}

export default connect(
    (state: IRootState): ApplicationInsightsProviderProps => {
        return {
            user: state.auth.user,
            history: state.history
        };
    }
)(ApplicationInsightsProvider);